window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: '+ 769 +'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};
theme.recentlyViewedIds = [];

(function(){
  //document.addEventListener('contextmenu', event => event.preventDefault());
  let phsp;
  if ( document.body.classList.contains('template-product') ) {
    // new theme.Sections();
    new theme.AjaxProduct();
    var container = document.querySelectorAll('.product__media-list')[0];
    var sectionId = container.closest('section').getAttribute('id');
    phsp = new theme.Photoswipe(container, sectionId);
  }
  
  if ( document.getElementById('product-grid') ) {
    new theme.QuickAdd(document.getElementById('product-grid'));
  }

  let sliders = document.querySelectorAll('.grid-product-slider');
  if ( sliders ) {
    sliders.forEach((item) => {
      new theme.QuickAdd(item);
    });
  }
  
   function loadRecentlyProducts(theme) {
      console.log('jsfile');
      var recentIds = window.localStorage.getItem('recently-viewed');
      if (recentIds && typeof(recentIds) !== undefined) {
        theme.recentlyViewedIds = JSON.parse(recentIds);
      }

      // Stop if no data
      let container = document.querySelector('[data-section-type="recently-viewed"]');
      if (container && !theme.recentlyViewedIds.length) {
        container.classList.add('hide');
        return;
      }

      this.outputContainer = document.getElementById('RecentlyViewed');

      if ( !this.outputContainer ) return false;
      // var currentId = this.container.getAttribute('data-product-id');

      var url = '/search?view=recently-viewed&type=product&q=';

      var products = '';
      var i = 0;
     let maxProducts = 6;
      theme.recentlyViewedIds.forEach(function(val) {
        // Skip current product
        // if (val === currentId) {
        //   return;
        // }

        // Stop at max
        if (i >= maxProducts) {
          return;
        }

        products += 'id:' + val + ' OR ';
        i++;
      });

      url = url + encodeURIComponent(products);
     
      fetch(url).then(function(response) {
        return response.text();
      }).then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var count = doc.querySelectorAll('.product-grid').length;
        // let containerOut = document.getElementById('RecentlyViewed');
        if (count > 0) {
          var results = doc.querySelector('.product-grid');
          this.outputContainer.append(results);
          new theme.QuickAdd(this.outputContainer);
          container.classList.remove('hide');
        } else {
          this.outputContainer.classList.add('hide');
        }

    });
  }
  loadRecentlyProducts(theme);

  function setRecentlyProducts(theme) {
    var productCurrent = document.querySelector('[name="product-id"]');
    theme.recentlyViewedIds.forEach(function(val) {
      if (val === null ) {
        theme.recentlyViewedIds = [];
      }
    });
    if ( !productCurrent ) return false;
    let id = productCurrent.value;

    if (!id) return;

    // Remove current product if already in recently viewed array
    var i = theme.recentlyViewedIds.indexOf(id);
    if (i > -1) {
      theme.recentlyViewedIds.splice(i, 1);
    } 
    
    theme.recentlyViewedIds.unshift(id);
    if ( theme.recentlyViewedIds.length > 6 ) {
      theme.recentlyViewedIds.length = 6;
    }
    
    // theme.recentlyViewedIds = theme.recentlyViewedIds.slice(1,6);

    if (theme.config.hasLocalStorage) {
      window.localStorage.setItem('recently-viewed', JSON.stringify(theme.recentlyViewedIds));
    }
  }
  setRecentlyProducts(theme);

  
})();

(function($) {
      
  $(document).ready(function() {

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    var isOnIOS = navigator.userAgent.match(/iPad/i)|| navigator.userAgent.match(/iPhone/i);
    var eventName = isOnIOS ? "pagehide" : "beforeunload";
    window.addEventListener(eventName, (event) => {
      var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      var centerX = windowWidth / 2;
      var centerY = windowHeight / 2;
      
      var elementsInCenter = document.elementsFromPoint(centerX + 100, centerY);
      let centeredProductId = $(elementsInCenter[0])
                              .closest('li.grid__item').attr('data-product-id');
      
      if ( $('#pagination-wrapper .infinite_next a').length > 0 ) {
        var link = $('#pagination-wrapper .infinite_next a').attr('href');
        var url = new URL(link, 'https://zurmarket.co.il/');
        var page = url.searchParams.get("page");
        var url = new URL(location.href);
        url.searchParams.set("IdToScroll", centeredProductId);
        url.searchParams.set("page", page - 1);
        var newURL = url;
        history.replaceState({}, '', newURL);
      }
    });
    
    var url = new URL(location.href);
    var IdToScroll = url.searchParams.get("IdToScroll");
    if ( IdToScroll ) { 
      let toScroll = $(`li.grid__item[data-product-id="${IdToScroll}"]`);
      if ( ! toScroll ) return false;
      if ( toScroll ) {
        var windowHeight = $(window).height();
        var elementHeight = toScroll.outerHeight();
        if ( ! toScroll.offset() ) return false;
        var scrollPosition = toScroll.offset().top - (windowHeight / 2) + (elementHeight / 2);
        $('html, body').animate({
            scrollTop: scrollPosition
        }, 500);
      }
      
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete("IdToScroll");
      const newUrl = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`;
      history.replaceState(null, "", newUrl);
    }

    
    // function hasGetParameter(param) {
    //     const urlParams = new URLSearchParams(window.location.search);
    //     return urlParams.has(param);
    // }
    
    // function performActionIfParamAbsent() {
    //     if (!hasGetParameter('sort_by') && $('body').hasClass('template-collection') ) {
    //       const currentUrl = new URL(window.location.href);
    //       currentUrl.searchParams.set('sort_by', 'best-selling');
    //       window.location.href = currentUrl.toString();
    //     }
    // }
    
    // performActionIfParamAbsent(); 

    $('body').on('click', '.continue_shop', function(e) {
      e.preventDefault();
      $('.js-close-header-cart').trigger('click');
    });
    
    $('.faq_block_container .faq_title').on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
    });
    
    /**
     * change looks for product collection page
    */
    $('body').on('click', 'button[data-view]', function(e) {
      e.preventDefault();
      $('button[data-view]').removeClass('is-active');
      $(this).addClass('is-active');
      let view = $(this).attr('data-view');
      $('#product-grid').attr('data-view', view);
    })
   
    function setSlideHeight(that){
      // $('.gallery-thumbs').css({height:'auto'});
      // var currentSlide = that.activeIndex;
      // var newHeight = $(that.slides[currentSlide]).height();
      if ( $('.gallery-thumbs .swiper-slide').length < 5 ) {
        $('.gallery-thumbs .swiper-wrapper').addClass('centered_slider');
      }
      $('.gallery-thumbs .swiper-slide').css({ height : '85px' })
      // that.update();
     }

    var galleryThumbs, galleryMain; 
    /*
    * slider swiper for single product page
    */
    if ( $(window).width() > 750 ) {
      let slides = $('.gallery-main .product__media-item');
      if ( $('.gallery-main .product__media-item').length > 1 ) {
        galleryThumbs = new Swiper(".gallery-thumbs", {
          // centeredSlides: false,
          // centeredSlidesBounds: false,
          slidesPerView: 5,
          // watchOverflow: false,
          // watchSlidesVisibility: true,
          // watchSlidesProgress: true,
          // direction: 'vertical',
          autoHeight: true,
          initialSlide: 0,
          autoScrollOffset: 1,
          spaceBetween: 15,
          slideToClickedSlide: true,
          // centeredSlides: true,
          // loop: true,
          // mousewheel: {
          //   releaseOnEdges: true,
          // },
          on:{
            init: function(){
              setSlideHeight(this);
            },
            slideChangeTransitionEnd:function(){
              setSlideHeight(this);
            }
          }
        });
        galleryMain = new Swiper(".gallery-main", {
          // watchOverflow: true,
          // watchSlidesVisibility: true,
          // watchSlidesProgress: true,
          // preventInteractionOnTransition: true,
          slideToClickedSlide: true,
          slidesPerView: 1,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          // effect: 'coverflow',
          thumbs: {
            swiper: galleryThumbs
          }
        });
        galleryMain.on('slideChangeTransitionStart', function() {
          galleryThumbs.slideTo(galleryMain.activeIndex);
        });
        
        galleryThumbs.on('transitionStart', function(){
          galleryMain.slideTo(galleryThumbs.activeIndex);
        });
      } else {
         $('.gallery-thumbs .swiper-wrapper').removeClass('swiper-wrapper');
        $('.gallery-thumbs .swiper-button-prev').remove();
        $('.gallery-thumbs .swiper-button-next').remove();
        $('.gallery-thumbs .swiper-pagination').remove();
        $('.gallery-thumbs .swiper-container').removeClass('swiper-container');
      }
      
      
      
    } else {
      if ( $('.gallery-main .product__media-item').length > 1 ) {
        galleryMain = new Swiper(".gallery-main", {
          // loop: true,
          loopedSlides: 3, 
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: true,
          centeredSlidesBounds: true,
          slideToClickedSlide: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          thumbs: {
            swiper: galleryThumbs
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          }
        });
      } else {
        $('.gallery-main .swiper-wrapper').removeClass('swiper-wrapper');
        $('.gallery-main.swiper-container').removeClass('swiper-container');
        $('.gallery-main .swiper-button-prev').remove();
        $('.gallery-main .swiper-button-next').remove();
        $('.gallery-main .swiper-pagination').remove();
      }
    }

    // galleryMain.on('slideChange', function () {
    //   // Получаем индекс активного слайда
    //   var activeIndex = galleryMain.activeIndex;
    //   if ( galleryMain.activeIndex < 5 ) {
    //     // galleryThumbs.slideTo(activeIndex + 2);
    //   }
      
    // });

    if ( $('.template-product [name="Color"]:checked').length > 0 ) {
      let currentVariant = $('[name="Color"]:checked').val();
      $('variant-radios .product-form__input .current_color').text(currentVariant);
    }

    if ( $('.template-product [name="color"]:checked').length > 0 ) {
      let currentVariant = $('[name="color"]:checked').val();
      $('variant-radios .product-form__input .current_color').text(currentVariant);
    }
    
    /**
    * code for change slides in product slide for each variant
    */
    let productCur = $('[data-tb-variants-json]').attr('data-tb-variants-json');
    if (productCur) {
      productCur = JSON.parse(productCur);
    }
    
    function variantImage(val) {
      var selectedVariantId = val;
      const variant = productCur.filter(v => v.title === selectedVariantId);
      
      if ( $('[date-for-slick]').length > 1 && $('[date-for-slick="' + variant[0].featured_media.id + '"]').length > 0 ) {
        activeMedia = document.querySelector(`[date-for-slick="${variant[0].featured_media.id}"]`).getAttribute('aria-label');
        var numbers = activeMedia.split("/");
        var firstNumber = parseInt(numbers[0]);
        galleryMain.slideTo(firstNumber - 1);
        galleryMain.slideTo(firstNumber - 1);
      }
    } 

    $('body').on('change', '[name="גודל"]', function() {
      var selectedVariantId = $(this).val();
      variantImage(selectedVariantId);
    });
    
    $('body').on('change', '[name="Color"]', function() {
      let currentVariant = $(this).closest('variant-radios').find('[name="Color"]:checked').val();
      $(this).closest('variant-radios').find('.product-form__input .current_color').text(currentVariant);
      var selectedVariantId = $(this).val();
      variantImage(selectedVariantId);
    });

    $('body').on('change', '[name="color"]', function() {
      let currentVariant = $(this).closest('variant-radios').find('[name="color"]:checked').val();
      $(this).closest('variant-radios').find('.product-form__input .current_color').text(currentVariant);
      var selectedVariantId = $(this).val();
      variantImage(selectedVariantId);
    });

    let variatn = $('[name="Color"]:checked');
    if ( variatn.length > 0 ) {
      var selectedVariantId = variatn.val();
      variantImage(selectedVariantId);
    }

    let variatn1 = $('[name="color"]:checked');
    if ( variatn1.length > 0 ) {
      var selectedVariantId = variatn.val();
      variantImage(selectedVariantId);
    }
    
    /**
    * code for toggle sorting in mobile filter
    */
    $('.mobile-facets__sort .label_box').on('click', function(e) {
      if ( $(window).width() > 750 ) return false;
      e.preventDefault();
      $(this).closest('.mobile-facets__sort').toggleClass('active');
    });

    let scrolledHeader = $('#SiteHeader').innerHeight() + 96;

    if ( $(window).width() < 750 && $('.facets-vertical .facets-wrapper').length > 0 ) {
      $('.facets-vertical .facets-wrapper').css('top', scrolledHeader);
    }
    if ( $(window).width() < 750 && $('.facets-vertical .facets-wrapper').length > 0 && $('menu-drawer.mobile-facets__wrapper').length > 0 ) {
      let scrolledHeaderFilter = $('menu-drawer.mobile-facets__wrapper').innerHeight() + scrolledHeader;
      let activeFiltersHeight;
      if ( $('.active-facets.active-facets-mobile facet-remove').length > 0 ) {
        activeFiltersHeight = $('.active-facets.active-facets-mobile').innerHeight();
        scrolledHeaderFilter += activeFiltersHeight;
      }
      $('#FacetFiltersFormMobile').css('top', scrolledHeaderFilter);
    }

    function checkLenghtDesc() {
      let desc = $('#collection-description-boa');
      desc.css('display', 'block');
      if ( desc.find('> .enlarge-text').innerHeight() > 63 ) {
        desc.css('display', '-webkit-box');
      } else {
        $('#collection-show-description').hide();
      }
    }
    checkLenghtDesc();

    $('.explaination').on('click', function(e) {
      e.preventDefault();
      let heightExp = $(this).find('.explanation_content');
      heightExp.css('bottom', -heightExp.innerHeight() / 2 + 15 );
      $(this).toggleClass('active');
    })

    /**
    * change images in loop on hover
    */
    $('.grid-product__colors .color-swatch').on('mouseover', function() {
      let curImage = $(this).attr('data-variant-image');
      $(this).closest('.grid-product').find('.color_variant_img.grid-product__color-image').css('backgroundImage', `url(${curImage})`).addClass('is-active');
    })
    $('.grid-product__colors .color-swatch').on('mouseleave', function() {
      let curImage = $(this).attr('data-variant-image');
      $(this).closest('.grid-product').find('.color_variant_img.grid-product__color-image').css('backgroundImage', '').removeClass('is-active');
    })
    $('.grid-product__colors .color-swatch').on('click', function(e) {
      e.preventDefault();
      let newHref = $(this).closest('.grid-product').find('.full-unstyled-link').attr('href');
      window.location.href = newHref;
    });

    /**
     *
     * @param name , valuem , time
     * @returns string value
     */
    function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      // d.setTime(d.getTime() + (exdays*24*60*60*1000));
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      let expires = 'expires='+ d.toUTCString();
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    /**
     *
     * @param name
     * @returns string value
     */
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }

    $('#CustomerEmail').on('blur', function() {
      setCookie( 'сustomerEmail', $(this).val(), 30 );
    });

    if ( $('#CustomerEmail').length > 0 && getCookie('сustomerEmail') ) {
      $('#CustomerEmail').val(getCookie('сustomerEmail'));
    }
    
  })
})(window.jQuery)

var PriceRange = class extends HTMLElement {
  #abortController;
  connectedCallback() {
    this.#abortController = new AbortController();
    const rangeLowerBound = this.querySelector('input[type="range"]:first-child'), rangeHigherBound = this.querySelector('input[type="range"]:last-child'), textInputLowerBound = this.querySelector('input[name="filter.v.price.gte"]'), textInputHigherBound = this.querySelector('input[name="filter.v.price.lte"]');
    textInputLowerBound.addEventListener("focus", () => textInputLowerBound.select(), { signal: this.#abortController.signal });
    textInputHigherBound.addEventListener("focus", () => textInputHigherBound.select(), { signal: this.#abortController.signal });
    textInputLowerBound?.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1), event.target.min);
      rangeLowerBound.value = event.target.value;
      rangeLowerBound.parentElement.style.setProperty("--range-min", `${parseInt(rangeLowerBound.value) / parseInt(rangeLowerBound.max) * 100}%`);
    }, { signal: this.#abortController.signal });
    textInputHigherBound?.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1), event.target.max);
      rangeHigherBound.value = event.target.value;
      rangeHigherBound.parentElement.style.setProperty("--range-max", `${parseInt(rangeHigherBound.value) / parseInt(rangeHigherBound.max) * 100}%`);
    }, { signal: this.#abortController.signal });
    rangeLowerBound?.addEventListener("change", (event) => {
      event.stopPropagation();
      textInputLowerBound.value = event.target.value;
      textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this.#abortController.signal });
    rangeHigherBound?.addEventListener("change", (event) => {
      event.stopPropagation();
      textInputHigherBound.value = event.target.value;
      textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this.#abortController.signal });
    rangeLowerBound?.addEventListener("input", (event) => {
      event.target.value = Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1);
      event.target.parentElement.style.setProperty("--range-min", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      textInputLowerBound.value = event.target.value;
    }, { signal: this.#abortController.signal });
    rangeHigherBound?.addEventListener("input", (event) => {
      event.target.value = Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1);
      event.target.parentElement.style.setProperty("--range-max", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
      textInputHigherBound.value = event.target.value;
    }, { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
};
if (!window.customElements.get("price-range")) {
  window.customElements.define("price-range", PriceRange);
}

window.addEventListener('DOMContentLoaded', () => {
  const originalContainer = document.querySelector('.template-article .page-content');
  if (!originalContainer) return;

  const newMainWrapper = document.createElement('div');
  newMainWrapper.classList.add('split__main');

  const newSidebarWrapper = document.createElement('div');
  newSidebarWrapper.classList.add('split__sidebar');

  Array.from(originalContainer.children).forEach(child => {
    console.log(child)
    if (child.matches('.blog-layout__sidebar') || child.matches('.featured-collection-section-container')) {
      newSidebarWrapper.appendChild(child);
    } else {
      newMainWrapper.appendChild(child);
    }
  });

  // Clear original and append new structure
  originalContainer.innerHTML = '';
  originalContainer.appendChild(newMainWrapper);
  originalContainer.appendChild(newSidebarWrapper);
});


